import React, { useLayoutEffect } from "react";

export const useButtonsClassesEffect = ({ wrRef, attachment }: { wrRef: React.RefObject<HTMLDivElement>, attachment: any }) => {
    useLayoutEffect(() => {
        wrRef.current?.querySelectorAll('.ac-pushButton').forEach((button, idx) => {
            const { channelData: { buttonClass = "" } = {} } = {} = attachment.content.buttons[idx] || {};
            buttonClass && button.classList.add(buttonClass); // TODO: add default class
        });
    }); // , [attachment]
};